// import React, { useEffect, useState } from "react";
// import {
//   Row,
//   Col,
//   Card,
//   Button,
//   Typography,
//   notification,
//   Form,
//   Input,
//   Select,
//   DatePicker,
//   InputNumber,
//   Space,
//   Upload
// } from "antd";
// import axios from "axios";
// import { UserOutlined, PhoneOutlined, CalendarOutlined, CheckCircleOutlined, UploadOutlined } from '@ant-design/icons';
// import moment from 'moment';
// import { useHistory, useParams } from "react-router-dom";
// import { baseUrl } from "../../config";

// const { Title } = Typography;
// const { Item } = Form;
// const { Option } = Select;
// const { TextArea } = Input;

// function StaffForm({ userId }) {


//   // const { id } = useParams(); // Extract id from URL
//   const history = useHistory();
//   const [form] = Form.useForm();
//   const [isUpdateMode, setIsUpdateMode] = useState(false);
//   const [txnDate, setTxnDate] = useState();
//   const [staffList, setStaffList] = useState([]);
//   const [meetingDate, setMeetingDate] = useState();
//   const [startDate, setStartDate] = useState();
//   const [status, setStatus] = useState('Pending');
//   const [imageUrl, setImageUrl] = useState(null); // Store the image URL if already uploaded
//   const [fileList, setFileList] = useState([]); // Store the image file list for Upload


//   useEffect(() => {

//     getStaffList();
//     // Check if id exists to determine if it's an update mode
//     if (userId) {
//       setIsUpdateMode(true);
//       fetchRoleDetails();
//     }
//   }, [userId]);



//   const fetchRoleDetails = async () => {
//     try {
//       const response = await axios.get(`${baseUrl}/work_managment/read/${userId}`, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem('accessToken')}`, // Include access token in headers
//         },
//       });
//       if (response.status === 200) { 
//         // setRoleData(response.data.result);
//         form.setFieldsValue(response.data.result); // Populate form fields with fetched data
//         setTxnDate(response.data.result.assigned_date ? response.data.result.assigned_date : null) // Format the date if present)
//          setStartDate(response.data.result.date_completion ? response.data.result.date_completion : null) // Format the date if present)
//         setStatus(response.data.result.status); // Populate status from fetched data

//         if (response.data.result.file_document) {
//           setImageUrl(response.data.result.file_document);
//           setFileList([
//             {
//               uid: '-1',
//               name: 'File',
//               status: 'done',
//               url: response.data.result.file_document,
//             },
//           ]);
//         }


//       } else {
//         notification.info({
//           message: 'Info',
//           description: response.data.message,
//           placement: 'topRight'
//         });
//       }
//     } catch (error) {
//       console.error("API error:", error);
//       notification.info({
//         message: 'Info',
//         description: error.response?.data?.message,
//         placement: 'topRight'
//       });
//     }
//   };

//   const onFinish = async (values) => {

//     try {


//       const formData = new FormData(); // Create a FormData object to handle files and form data

//       // Format the dates
//       if (txnDate) {
//         const formattedDate = moment(txnDate).format('YYYY-MM-DD');
//         formData.append('assigned_date', formattedDate);
//       } else {
//         formData.append('assigned_date', '');
//       }

//       if (startDate) {
//         const formattedMeetingDate = moment(startDate).format('YYYY-MM-DD');
//         formData.append('date_completion', formattedMeetingDate);
//       } else {
//         formData.append('date_completion', '');
//       }
 

//       // Append other form fields to formData
//       formData.append('assigned_by', values.assigned_by);
//       formData.append('description', values.description);
//       formData.append('assigned_to', values.assigned_to);
//       formData.append('remark_by_assignee', values.remark_by_assignee);
//       formData.append('status_task', values.status);
//       formData.append('remark_by_staff', values.remark_by_staff);

//       console.log('values',values)
       

//       // Append image (if any)
//       if (values.image && values.image.length > 0 && values.image[0].originFileObj) {
//         formData.append('file', values.image[0].originFileObj); // Append the image file
//       }

//       console.log('formData',formData) 
 

//       if (isUpdateMode) {
//         const response = await axios.patch(`${baseUrl}/work_managment/update/${userId}`, formData, {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem('accessToken')}`, // Include access token in headers
//             'Content-Type': 'multipart/form-data' // Ensure multipart content type for FormData
//           },
//         });
//         if (response.status === 200) {
//           notification.success({
//             message: 'Success',
//             description: 'Record updated successfully!',
//             placement: 'topRight'
//           });
//           history.push('/work_managment');
//         } else {
//           notification.info({
//             message: 'Info',
//             description: response.data.message,
//             placement: 'topRight'
//           });
//         }
//       } else {
//         const response = await axios.post(`${baseUrl}/work_managment/create`, formData, {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem('accessToken')}`, // Include access token in headers
//             'Content-Type': 'multipart/form-data' // Ensure multipart content type for FormData
//           },
//         });


        
//         if (response.status === 200) {
//           notification.success({
//             message: 'Success',
//             description: 'Work Managment added successfully!',
//             placement: 'topRight'
//           });
//           form.resetFields();
//           history.push('/work_managment');
//         } else {
//           notification.info({
//             message: 'Info',
//             description: response.data.message,
//             placement: 'topRight'
//           });
//         }
//       }
//     } catch (error) {
//       console.error("API error:", error);
//       notification.info({
//         message: 'Info',
//         description: error.response?.data?.message,
//         placement: 'topRight'
//       });
//     }
//   };



//   const handleDateChange = (date, dateString) => {
//     if (date) {
//       const formattedDate = moment(date).format('YYYY-MM-DD');
//       setTxnDate(formattedDate)
//     } else {
//       setTxnDate(null);
//     }
//   };

//   const handleMeetingDateChange = (date, dateString) => {
//     if (date) {
//       const formattedDate = moment(date).format('YYYY-MM-DD');
//       setMeetingDate(formattedDate)
//     } else {
//       setMeetingDate(null);
//     }
//   };

//   const handleStartDateChange = (date, dateString) => {
//     if (date) {
//       const formattedDate = moment(date).format('YYYY-MM-DD');
//       setStartDate(formattedDate)
//     } else {
//       setStartDate(null);
//     }
//   };

//   async function getStaffList() {
//     try {
//       const response = await axios.get(`${baseUrl}/staff/list`, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
//         }
//       });
//       if (response.data.status) {
//         setStaffList(response.data.result);
//       } else {
//         notification.info({
//           message: 'Info',
//           description: response.data.message,
//           placement: 'topRighft'
//         });
//       }
//     } catch (error) {
//       console.error("API error:", error);
//       notification.info({
//         message: 'Info',
//         description: error.response?.data?.message,
//         placement: 'topRight'
//       });
//     }
//   };

//   // Handle status change
//   const handleStatusChange = (value) => {
//     setStatus(value);
//   };



//   return (
//     <div className="tabled">
//       <Row gutter={[24, 0]}>
//         <Col xs="24" xl={24}>
//           <Card
//             bordered={false}
//             className="criclebox tablespace mb-24"
//             title={isUpdateMode ? "Update Work Managment" : "Add Work Managment"}
//           >
//             <Form
//               initialValues={{ status: "Pending" }}
//               style={{ "padding": "20px" }} form={form} onFinish={onFinish} layout="vertical">
//               <Row gutter={[16, 16]}>


//                 <Col xs={24} sm={4} lg={4}>
//                   <Item
//                     label="Assigned By"
//                     name="assigned_by"
//                     rules={[{ required: true, message: 'Please Enter  Assigned By' }
//                     ]}
//                   >
//                     <Input placeholder="Enter Assigned By" />
//                   </Item>
//                 </Col>

//                 <Col xs={24} sm={4} lg={4}>
//                   <Item label="Assigned Date" >
//                     <DatePicker onChange={handleDateChange} value={txnDate && txnDate != "0000-00-00" && moment(txnDate)} className="filter_dob" format="DD-MM-YYYY" placeholder="Select Assigned Date" prefix={<CalendarOutlined />} />

//                   </Item>
//                 </Col>


//                 <Col xs={24} sm={8} lg={8}>
//                   <Item
//                     label="Description"
//                     name="description"
//                     rules={[{ required: true, message: 'Please Enter Description' }]}
//                   >
//                     <TextArea placeholder="Enter Description" />
//                   </Item>
//                 </Col>

//                 <Col xs={24} sm={12} lg={8}>
//                   <Item
//                     label="Work Document"
//                     name="image"
//                     valuePropName="file"
//                     rules={[{ required: false, message: 'Please upload an image' }]}
//                   >
//                     <Upload
//                       name="image"
//                       listType="picture" 
//                       beforeUpload={() => false}  
//                       onChange={({ fileList: newFileList }) => {
//                         setFileList(newFileList); // Update the file list when a new file is selected
//                         form.setFieldsValue({ image: newFileList }); // Store the file list in form fields
//                       }}
//                       fileList={fileList} // Use fileList state to control the display
//                       maxCount={1} // Restrict to a single image
//                     >
//                       <Button icon={<UploadOutlined />}>Click to Upload</Button>
//                     </Upload>



//                   </Item>
//                 </Col>


//                 <Col xs={24} sm={6} lg={4}>

//                   <Item className="custom-form-item" label="Assigned To" name="assigned_to">
//                     <Select style={{ width: '100%' }} placeholder="Select Staff"  >
//                       <Option value="">Select Staff</Option>
//                       {staffList && staffList.map((item, i) => (
//                         <Option value={item.id}>{item.firstName} {item.lastName}</Option>
//                       ))}
//                     </Select>
//                   </Item>

//                 </Col>

//                 <Col xs={24} sm={12} lg={4}>
//                   <Item
//                     label="Remark By Assignee"
//                     name="remark_by_assignee"
//                   >
//                     <Input placeholder="Enter Remark By Assignee" />
//                   </Item>
//                 </Col>



//                 <Col xs={24} sm={12} lg={4}>

//                   <Item className="custom-form-item" label="Status" name="status"
//                     rules={[{ required: true, message: 'Select Status' }]}
//                   >
//                     <Select value={status} onChange={handleStatusChange} className="status" placeholder="Select Account" defaultValue="Pending" >
//                       <Option value="Pending">Pending</Option>
//                       <Option value="InProcess">InProcess</Option>
//                       <Option value="Completed">Completed</Option>
//                     </Select>
//                   </Item>
//                 </Col>

//                 {status === 'InProcess' && (
//                   <Col xs={24} sm={4} lg={4}>
//                     <Item label="Date Completion" >
//                       <DatePicker onChange={handleStartDateChange} value={startDate && startDate != "0000-00-00" && moment(startDate)} className="filter_dob" format="DD-MM-YYYY" placeholder="Select Date Completion" prefix={<CalendarOutlined />} />

//                     </Item>
//                   </Col>
//                 )}

//                 <Col xs={24} sm={12} lg={4}>
//                   <Item
//                     label="Remark By Staff"
//                     name="remark_by_staff"
//                   >
//                     <Input placeholder="Enter Remark By Staff" />
//                   </Item>
//                 </Col>


//               </Row>
//               <Row style={{ textAlign: 'right' }}>
//                 <Col xs={24} sm={24} lg={24}>
//                   <Item>
//                     <Button
//                       type="primary"
//                       htmlType="submit"
//                       style={{ marginRight: '10px' }} // Add space between buttons
//                     >
//                       {isUpdateMode ? "Update" : "Save"}
//                     </Button>


//                   </Item>
//                 </Col>
//               </Row>

//             </Form>
//           </Card>
//         </Col>
//       </Row>
//     </div>
//   );
// }

// export default StaffForm;


import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  Button,
  Typography,
  notification,
  Form,
  Input,
  Select,
  DatePicker,
  InputNumber,
  Space,
  Upload,
  Divider,
  Alert
} from "antd";
import axios from "axios";
import { 
  UserOutlined, 
  PhoneOutlined, 
  CalendarOutlined, 
  CheckCircleOutlined, 
  UploadOutlined,
  ProjectOutlined,
  EditOutlined,
  SaveOutlined,
  FileTextOutlined,
  TeamOutlined,
  ClockCircleOutlined,
  SyncOutlined
} from '@ant-design/icons';
import moment from 'moment';
import { useHistory, useParams } from "react-router-dom";
import { baseUrl } from "../../config";

const { Title, Text } = Typography;
const { Item } = Form;
const { Option } = Select;
const { TextArea } = Input;

function WorkManagementForm({ userId, onRefreshData = () => {} }) {
  const history = useHistory();
  const [form] = Form.useForm();
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [assignedDate, setAssignedDate] = useState(null);
  const [completionDate, setCompletionDate] = useState(null);
  const [status, setStatus] = useState('Pending');
  const [staffList, setStaffList] = useState([]);
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    getStaffList();
    if (userId) {
      setIsUpdateMode(true);
      fetchWorkDetails();
    }
  }, [userId]);

  const fetchWorkDetails = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${baseUrl}/work_managment/read/${userId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
      if (response.status === 200) {
        const data = response.data.result;
        form.setFieldsValue(data);
        
        // Handle Assigned Date
        if (data.assigned_date && data.assigned_date !== '0000-00-00' && moment(data.assigned_date).isValid()) {
          setAssignedDate(data.assigned_date);
        } else {
          setAssignedDate(null);
        }
        
        // Handle Completion Date
        if (data.date_completion && data.date_completion !== '0000-00-00' && moment(data.date_completion).isValid()) {
          setCompletionDate(data.date_completion);
        } else {
          setCompletionDate(null);
        }
        
        // Handle Status
        setStatus(data.status || 'Pending');
        
        // Handle File Document
        if (data.file_document) {
          setFileList([
            {
              uid: '-1',
              name: 'Work Document',
              status: 'done',
              url: data.file_document,
            },
          ]);
        }
      }
    } catch (error) {
      notification.error({
        message: 'Error',
        description: 'Failed to fetch work details',
        placement: 'topRight'
      });
    } finally {
      setLoading(false);
    }
  };

  const getStaffList = async () => {
    try {
      const response = await axios.get(`${baseUrl}/staff/list`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        }
      });
      if (response.data.status) {
        setStaffList(response.data.result);
      }
    } catch (error) {
      console.error("Staff list API error:", error);
    }
  };

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const formData = new FormData();

      // Handle Assigned Date
      if (assignedDate && assignedDate !== '0000-00-00') {
        const formattedDate = moment(assignedDate).format('YYYY-MM-DD');
        formData.append('assigned_date', formattedDate);
      }

      // Handle Completion Date - only append if it has a valid value
      if (completionDate && completionDate !== '0000-00-00') {
        const formattedCompletionDate = moment(completionDate).format('YYYY-MM-DD');
        formData.append('date_completion', formattedCompletionDate);
      }

      // Append other form fields - only append non-empty values
      if (values.assigned_by) formData.append('assigned_by', values.assigned_by);
      if (values.description) formData.append('description', values.description);
      if (values.assigned_to) formData.append('assigned_to', values.assigned_to);
      if (values.remark_by_assignee) formData.append('remark_by_assignee', values.remark_by_assignee);
      if (values.status || status) formData.append('status_task', values.status || status);
      if (values.remark_by_staff) formData.append('remark_by_staff', values.remark_by_staff);

      // Handle file upload - check if there's a new file
      if (fileList.length > 0 && fileList[0].originFileObj) {
        formData.append('image', fileList[0].originFileObj);
      }

      // Make API request
      let response;
      if (isUpdateMode) {
        response = await axios.patch(`${baseUrl}/work_managment/update/${userId}`, formData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            'Content-Type': 'multipart/form-data'
          },
        });
      } else {
        response = await axios.post(`${baseUrl}/work_managment/create`, formData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            'Content-Type': 'multipart/form-data'
          },
        });
      }

      if (response.status === 200) {
        notification.success({
          message: 'Success',
          description: isUpdateMode ? 'Work item updated successfully!' : 'Work item created successfully!',
          placement: 'topRight'
        });
        
        onRefreshData();
        
        if (!isUpdateMode) {
          form.resetFields();
          setAssignedDate(null);
          setCompletionDate(null);
          setStatus('Pending');
          setFileList([]);
        }
      }
    } catch (error) {
      notification.error({
        message: 'Error',
        description: error.response?.data?.message || 'Operation failed',
        placement: 'topRight'
      });
    } finally {
      setLoading(false);
    }
  };

  const handleAssignedDateChange = (date) => {
    if (date) {
      const formattedDate = moment(date).format('YYYY-MM-DD');
      setAssignedDate(formattedDate);
    } else {
      setAssignedDate(null);
    }
  };

  const handleCompletionDateChange = (date) => {
    if (date) {
      const formattedDate = moment(date).format('YYYY-MM-DD');
      setCompletionDate(formattedDate);
    } else {
      setCompletionDate(null);
    }
  };

  const handleStatusChange = (value) => {
    setStatus(value);
    // If status is not InProcess, clear completion date
    if (value !== 'InProcess') {
      setCompletionDate(null);
      // Don't set form field to avoid sending empty string
    }
  };

  const handleFileChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };

  const beforeUpload = (file) => {
    const isValidType = file.type === 'application/pdf' || 
                       file.type === 'image/jpeg' || 
                       file.type === 'image/png' || 
                       file.type === 'image/jpg' ||
                       file.type === 'application/msword' ||
                       file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    
    if (!isValidType) {
      notification.error({
        message: 'Error',
        description: 'You can only upload PDF, DOC, DOCX, JPG, PNG files!',
        placement: 'topRight'
      });
      return false;
    }
    
    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      notification.error({
        message: 'Error',
        description: 'File must be smaller than 5MB!',
        placement: 'topRight'
      });
      return false;
    }
    
    return false; // Prevent auto upload
  };

  const getStatusInfo = (statusValue) => {
    switch (statusValue) {
      case 'Pending':
        return {
          color: '#fa8c16',
          icon: <ClockCircleOutlined />,
          description: 'Work item is waiting to be started'
        };
      case 'InProcess':
        return {
          color: '#1890ff',
          icon: <SyncOutlined spin />,
          description: 'Work item is currently in progress'
        };
      case 'Completed':
        return {
          color: '#52c41a',
          icon: <CheckCircleOutlined />,
          description: 'Work item has been completed'
        };
      default:
        return {
          color: '#d9d9d9',
          icon: <ClockCircleOutlined />,
          description: 'Select work status'
        };
    }
  };

  const statusInfo = getStatusInfo(status);

  return (
    <Card
      bordered={false}
      style={{
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <ProjectOutlined style={{ color: '#1890ff', fontSize: '20px' }} />
          <Title level={4} style={{ margin: 0, color: '#1890ff' }}>
            {isUpdateMode ? "Update Work Assignment" : "Create New Work Assignment"}
          </Title>
        </div>
      }
      extra={
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {isUpdateMode ? (
            <EditOutlined style={{ color: '#1890ff', fontSize: '16px' }} />
          ) : (
            <FileTextOutlined style={{ color: '#52c41a', fontSize: '16px' }} />
          )}
          <Text type="secondary" style={{ fontSize: '12px' }}>
            {isUpdateMode ? 'Editing Mode' : 'Create Mode'}
          </Text>
        </div>
      }
    >
      <Form 
        form={form} 
        onFinish={onFinish} 
        layout="vertical"
        requiredMark={false}
        style={{ maxWidth: '100%' }}
        initialValues={{ status: 'Pending' }}
      >
        {/* Assignment Details Section */}
        <div style={{
          background: '#f8f9fa',
          padding: '20px',
          borderRadius: '8px',
          marginBottom: '24px',
          border: '1px solid #e9ecef'
        }}>
          <Title level={5} style={{ marginBottom: '16px', color: '#1890ff' }}>
            📋 Assignment Details
          </Title>
          <Row gutter={[20, 16]}>
            <Col xs={24} sm={12} lg={8}>
              <Item
                label={<Text strong>Assigned By</Text>}
                name="assigned_by"
                rules={[{ required: true, message: 'Please enter who assigned this work' }]}
              >
                <Input
                  prefix={<UserOutlined style={{ color: '#1890ff' }} />}
                  placeholder="Enter name of person assigning work"
                  style={{ borderRadius: '8px', height: '40px' }}
                />
              </Item>
            </Col>

            <Col xs={24} sm={12} lg={8}>
              <Item
                label={<Text strong>Assigned Date</Text>}
              >
                <DatePicker
                  onChange={handleAssignedDateChange}
                  value={assignedDate && assignedDate !== "0000-00-00" && moment(assignedDate).isValid() ? moment(assignedDate) : null}
                  format="DD-MM-YYYY"
                  placeholder="Select assignment date"
                  style={{ width: '100%', borderRadius: '8px', height: '40px' }}
                  suffixIcon={<CalendarOutlined style={{ color: '#1890ff' }} />}
                  allowClear
                />
              </Item>
            </Col>

            <Col xs={24} sm={12} lg={8}>
              <Item
                label={<Text strong>Assigned To</Text>}
                name="assigned_to"
                rules={[{ required: true, message: 'Please select staff member' }]}
              >
                <Select
                  placeholder="Select staff member"
                  style={{ borderRadius: '8px', height: '40px' }}
                  suffixIcon={<TeamOutlined style={{ color: '#1890ff' }} />}
                  showSearch
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {staffList.map((staff) => (
                    <Option key={staff.id} value={staff.id}>
                      {staff.firstName} {staff.lastName}
                    </Option>
                  ))}
                </Select>
              </Item>
            </Col>

            <Col xs={24}>
              <Item
                label={<Text strong>Work Description</Text>}
                name="description"
                rules={[{ required: true, message: 'Please enter work description' }]}
              >
                <TextArea
                  placeholder="Describe the work to be done in detail..."
                  style={{ borderRadius: '8px', minHeight: '100px' }}
                  rows={4}
                  maxLength={1000}
                  showCount
                />
              </Item>
            </Col>

            <Col xs={24} sm={12} lg={8}>
              <Item
                label={<Text strong>Work Document</Text>}
                name="image"
              >
                <Upload
                  name="image"
                  listType="picture-card"
                  beforeUpload={beforeUpload}
                  onChange={handleFileChange}
                  fileList={fileList}
                  maxCount={1}
                  style={{ width: '100%' }}
                >
                  {fileList.length === 0 && (
                    <div>
                      <UploadOutlined />
                      <div style={{ marginTop: 8 }}>Upload Document</div>
                    </div>
                  )}
                </Upload>
                <Text type="secondary" style={{ fontSize: '12px' }}>
                  Support: PDF, DOC, DOCX, JPG, PNG (Max 5MB)
                </Text>
              </Item>
            </Col>
          </Row>
        </div>

        {/* Status & Progress Section */}
        <div style={{
          background: '#f0f8ff',
          padding: '20px',
          borderRadius: '8px',
          marginBottom: '24px',
          border: '1px solid #d6e4ff'
        }}>
          <Title level={5} style={{ marginBottom: '16px', color: '#1890ff' }}>
            📊 Status & Progress
          </Title>
          <Row gutter={[20, 16]}>
            <Col xs={24} sm={12} lg={8}>
              <Item
                label={<Text strong>Work Status</Text>}
                name="status"
                rules={[{ required: true, message: 'Please select status' }]}
              >
                <Select
                  value={status}
                  onChange={handleStatusChange}
                  style={{ borderRadius: '8px', height: '40px' }}
                  placeholder="Select work status"
                >
                  <Option value="Pending">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <ClockCircleOutlined style={{ color: '#fa8c16' }} />
                      Pending
                    </div>
                  </Option>
                  <Option value="InProcess">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <SyncOutlined style={{ color: '#1890ff' }} />
                      In Process
                    </div>
                  </Option>
                  <Option value="Completed">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <CheckCircleOutlined style={{ color: '#52c41a' }} />
                      Completed
                    </div>
                  </Option>
                </Select>
              </Item>
              
              <Alert
                message={
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    {statusInfo.icon}
                    <Text strong style={{ color: statusInfo.color }}>
                      {status || 'No status selected'}
                    </Text>
                  </div>
                }
                description={statusInfo.description}
                type="info"
                showIcon={false}
                style={{ marginTop: '8px', borderRadius: '6px' }}
              />
            </Col>

            {status === 'InProcess' && (
              <Col xs={24} sm={12} lg={8}>
                <Item
                  label={<Text strong>Expected Completion Date</Text>}
                >
                  <DatePicker
                    onChange={handleCompletionDateChange}
                    value={completionDate && completionDate !== "0000-00-00" && moment(completionDate).isValid() ? moment(completionDate) : null}
                    format="DD-MM-YYYY"
                    placeholder="Select expected completion date"
                    style={{ width: '100%', borderRadius: '8px', height: '40px' }}
                    suffixIcon={<CalendarOutlined style={{ color: '#1890ff' }} />}
                    allowClear
                  />
                </Item>
              </Col>
            )}
          </Row>
        </div>

        {/* Remarks Section */}
        <div style={{
          background: '#fff7e6',
          padding: '20px',
          borderRadius: '8px',
          marginBottom: '24px',
          border: '1px solid #ffd591'
        }}>
          <Title level={5} style={{ marginBottom: '16px', color: '#fa8c16' }}>
            💬 Remarks & Comments
          </Title>
          <Row gutter={[20, 16]}>
            <Col xs={24} sm={12}>
              <Item
                label={<Text strong>Remark by Assignee</Text>}
                name="remark_by_assignee"
              >
                <TextArea
                  placeholder="Comments from the person doing the work..."
                  style={{ borderRadius: '8px', minHeight: '80px' }}
                  rows={3}
                  maxLength={500}
                  showCount
                />
              </Item>
            </Col>

            <Col xs={24} sm={12}>
              <Item
                label={<Text strong>Remark by Staff</Text>}
                name="remark_by_staff"
              >
                <TextArea
                  placeholder="Comments from supervisory staff..."
                  style={{ borderRadius: '8px', minHeight: '80px' }}
                  rows={3}
                  maxLength={500}
                  showCount
                />
              </Item>
            </Col>
          </Row>
        </div>

        {/* Form Actions */}
        <div style={{
          marginTop: '32px',
          paddingTop: '24px',
          borderTop: '1px solid #f0f0f0',
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '12px'
        }}>
          <Button
            size="large"
            onClick={() => form.resetFields()}
            style={{
              borderRadius: '8px',
              minWidth: '100px'
            }}
          >
            Reset Form
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            size="large"
            loading={loading}
            icon={isUpdateMode ? <EditOutlined /> : <SaveOutlined />}
            style={{
              borderRadius: '8px',
              minWidth: '140px',
              background: isUpdateMode 
                ? 'linear-gradient(135deg, #fa8c16 0%, #d46b08 100%)'
                : 'linear-gradient(135deg, #52c41a 0%, #389e0d 100%)',
              border: 'none'
            }}
          >
            {isUpdateMode ? 'Update Work Item' : 'Create Work Item'}
          </Button>
        </div>
      </Form>
    </Card>
  );
}

export default WorkManagementForm;